import axios from 'axios';

const requestCancelTokens = {};
export default {
  getData(url, params = {}, canUseCancelToken = true) {
    // if we have a pending request, cancel it
    if (requestCancelTokens[url]) {
      requestCancelTokens[url].cancel();
    }

    // save token
    requestCancelTokens[url] = axios.CancelToken.source();

    if (!canUseCancelToken) {
      return axios
        .get(url, { params })
        .then(response => response)
        .catch(error => {
          if (!axios.isCancel(error)) {
            // eslint-disable-next-line
            window.alert('An error has occurred. Please try again.');
          }
        });
    }

    return axios
      .get(url, { params, cancelToken: requestCancelTokens[url].token })
      .then(response => response)
      .catch(error => {
        if (!axios.isCancel(error)) {
          // eslint-disable-next-line
          window.alert('An error has occurred. Please try again.');
        }
      });
  },
  deleteData(url, params = {}) {
    return axios
      .delete(url, { params })
      .then(response => response)
      .catch(() => {
        // eslint-disable-next-line
        window.alert('An error has occurred. Please try again.');
      });
  },
  postData(url, sendObj) {
    return axios
      .post(url, sendObj)
      .then(response => response)
      .catch(error => {
        if (error.response.status === 400) {
          // eslint-disable-next-line
          window.alert('An error has occurred: Duplicate data.')
        }

        if (error.response.status === 500) {
          // eslint-disable-next-line
          window.alert('An error has occurred: Internal server error');
        }
        if (error.response.status !== 400 && error.response.status !== 500) {
          // eslint-disable-next-line
          window.alert('An error has occurred. Please try again.');
        }
      });
  },
  putData(url, sendObj) {
    return axios
      .put(url, sendObj)
      .then(response => response)
      .catch(() => {
        // eslint-disable-next-line
        window.alert('An error has occurred. Please try again.');
      });
  }
};
